import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; // Import the CSS file for styling

const Navbar = () => {
  return (
    <header className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src="/aalogo.png" alt="Abstinent Adolescents Logo" />
        </Link>
      </div>
      <nav className="navbar-links">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about-us">About Us</Link></li>
          <li><Link to="/our-story">Our Story</Link></li>
          <li><Link to="/what-we-believe">What We Believe</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/book-us">Book Us</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
